import { useFeatureFlagVariantKey } from 'posthog-js/react'
import { FEATURE_FLAG_VARIANTS, FeatureFlagVariant, FeatureFlagWithVariants } from 'constants/tracking'

const isVariantOf = <Flag extends FeatureFlagWithVariants>(flag: Flag, value: unknown): value is FeatureFlagVariant<Flag> =>
  typeof value === 'string' && (FEATURE_FLAG_VARIANTS[flag] as readonly string[]).includes(value)

export const useFeatureFlagVariantKeyTyped = <Flag extends FeatureFlagWithVariants>(flag: Flag): FeatureFlagVariant<Flag> | undefined => {
  const variant = useFeatureFlagVariantKey(flag)

  return isVariantOf(flag, variant) ? variant : undefined
}
